<template>
  <fieldset>
    <legend>조회 폼</legend>
    <div class="lookup-wrap">
      <dl>
        <dt><i class="fal fa-calendar-alt"></i>기간</dt>
        <dd>
          <select class="reseller-select" v-model="selectValue">
            <option
              v-for="option in options"
              :value="option.value"
              :key="option.value"
            >
              {{ option.text }}
            </option>
          </select>
        </dd>

        <dd>
          <span class="title">Start Month</span>
          <vue-monthly-picker
            v-model="selectedStartMonth"
            dateFormat="YYYY.MM"
            alignment="left"
            :clearOption="false"
            selectedBackgroundColor="#5393e2"
            :monthLabels="locale"
          />
          <i class="fal fa-calendar-check"></i>
        </dd>
        <dd>
          <span class="dash">-</span>
        </dd>
        <dd>
          <span class="title">End Month</span>
          <vue-monthly-picker
            v-model="selectedEndMonth"
            dateFormat="YYYY.MM"
            alignment="left"
            :clearOption="false"
            selectedBackgroundColor="#5393e2"
            :monthLabels="locale"
          />
          <i class="fal fa-calendar-check"></i>
        </dd>
      </dl>
      <dl>
        <dt><i class="fal fa-file-minus"></i>서비스</dt>
        <dd class="m-r-40 p-r-40">
          <label class="reseller-checkbox">
            <input
              type="checkbox"
              v-model="serviceCheckedAll"
              @change="$_serviceCheckedAll(serviceCheckedAll)"
            />
            <span class="reseller-checkbox__inner"></span>
            <span class="text">전체</span>
          </label>
        </dd>
        <dd v-for="row in serviceData" :key="row.value">
          <label class="reseller-checkbox">
            <input
              type="checkbox"
              v-model="row.checked"
              @change="$_updateServiceCheckAll(row.checked)"
              :value="row.value"
            />
            <span class="reseller-checkbox__inner"></span>
            <span class="text">{{ row.text }}</span>
          </label>
        </dd>
      </dl>
      <dl>
        <dt><i class="fal fa-file-invoice-dollar"></i>상태</dt>
        <dd class="m-r-40 p-r-40">
          <label class="reseller-checkbox">
            <input
              type="checkbox"
              v-model="statusCheckedAll"
              @change="$_statusCheckedAll(statusCheckedAll)"
            />
            <span class="reseller-checkbox__inner"></span>
            <span class="text">전체</span>
          </label>
        </dd>
        <dd v-for="row in statusData" :key="row.value">
          <label class="reseller-checkbox">
            <input
              type="checkbox"
              v-model="row.checked"
              @change="$_updateStatusCheckAll(row.checked)"
              :value="row.value"
            />
            <span class="reseller-checkbox__inner"></span>
            <span class="text">{{ row.text }}</span>
          </label>
        </dd>
      </dl>
      <div class="search-buttton-area">
        <reseller-button size="large" type="primary" @click="$_search()">
          검색
        </reseller-button>
        <reseller-button type="clear" @click="$_reset()">
          <i class="fal fa-redo"></i>
          검색 취소
        </reseller-button>
      </div>
    </div>
  </fieldset>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    serviceFilters: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selectedStartMonth: moment().subtract(1, 'years'),
      selectedEndMonth: moment(),
      startDate: '',
      endDate: '',
      selectValue: 'sales',
      options: [
        { text: '실적 발생 월', value: 'sales' },
        { text: '정산 월', value: 'calc' }
      ],
      serviceCheckedAll: true,
      statusCheckedAll: true,
      statusList: [
        { text: '결제 완료', value: '1', checked: true },
        { text: '결제 취소', value: 'C', checked: true },
        { text: '환불', value: 'R', checked: true }
      ],
      locale: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월'
      ]
    };
  },

  watch: {
    selectedStartMonth(date) {
      if (this.selectedStartMonth > this.selectedEndMonth) {
        alert('기간을 확인해 주세요.');
        this.selectedStartMonth = moment().subtract(1, 'years');
      } else {
        this.$_getStartDate();
      }
    },

    selectedEndMonth(date) {
      if (this.selectedEndMonth < this.selectedStartMonth) {
        alert('기간을 확인해 주세요.');
        this.selectedEndMonth = moment();
      } else {
        this.$_getEndDate();
      }
    }
  },
  computed: {
    serviceData() {
      let serviceData = [];

      this.serviceFilters.forEach(item => {
        serviceData.push({
          text: item.service_code_nm,
          value: item.service_code,
          checked: true
        });
      });
      return serviceData;
    },

    statusData() {
      let statusData = [];
      this.statusList.forEach(item => {
        statusData.push({
          text: item.text,
          value: item.value,
          checked: item.checked
        });
      });
      return statusData;
    }
  },

  mounted() {
    this.$_getStartDate();
    this.$_getEndDate();
  },

  methods: {
    $_getStartDate() {
      this.startDate = this.selectedStartMonth.format('YYYY-MM') + '-01';
    },

    $_getEndDate() {
      let temp = new Date(this.selectedEndMonth);
      let searchEndDate = new Date(temp.getFullYear(), temp.getMonth() + 1, 0);
      let endMonth =
        searchEndDate.getMonth() + 1 > 9
          ? searchEndDate.getMonth() + 1
          : '0' + (searchEndDate.getMonth() + 1);

      this.endDate =
        searchEndDate.getFullYear() +
        '-' +
        endMonth +
        '-' +
        searchEndDate.getDate();
    },

    $_serviceCheckedAll(checked) {
      for (let value in this.serviceData) {
        this.serviceData[value].checked = checked;
      }
      //this.$_search();
    },
    $_updateServiceCheckAll() {
      let trueCnt = this.serviceData.filter(value => value.checked == true);

      if (trueCnt.length == this.serviceData.length) {
        this.serviceCheckedAll = true;
      } else {
        this.serviceCheckedAll = false;
      }
      //this.$_search();
    },

    $_statusCheckedAll(checked) {
      for (let value in this.statusData) {
        this.statusData[value].checked = checked;
      }
      //this.$_search();
    },
    $_updateStatusCheckAll() {
      let trueCnt = this.statusData.filter(value => value.checked == true);

      if (trueCnt.length == 3) {
        this.statusCheckedAll = true;
      } else {
        this.statusCheckedAll = false;
      }
      //this.$_search();
    },

    $_search() {
      let params = {
        search_type: this.selectValue,
        start_date: this.startDate,
        end_date: this.endDate,
        serviceData: this.serviceData,
        statusData: this.statusData
      };

      this.$emit('search', params);
    },

    $_reset() {
      Object.assign(this.$data, this.$options.data());
      for (let i = 0; i < this.serviceData.length; i++) {
        this.serviceData[i].checked = true;
      }
      this.$_getStartDate();
      this.$_getEndDate();
      let params = {
        search_type: this.selectValue,
        start_date: this.startDate,
        end_date: this.endDate,
        serviceData: this.serviceData,
        statusData: this.statusData
      };
      this.$emit('search', params);
      //this.$_search();
    }
  }
};
</script>

<style lang="scss" scoped>
.reseller-select {
  margin-top: 10px;
}
</style>
